import { ObjectHelper } from "@osapp/helpers/objectHelper";
import { OsappError } from "@osapp/modules/errors/model/OsappError";

export class ForwardActionError extends OsappError {
	constructor(psMessage: string) {
		super(`Erreur d'action d'avancement d'une facture: ${psMessage}`);
		// Nécessaire pour que le 'instanceof ForwardActionError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, ForwardActionError);
	}
}